export const CAUSES_OF_DEATH = [
  'Natural Death',
  'Accidental Death',
  'Death from Pre-existing Condition'
];

const CAUSE_BY_BENEFIT_TYPE = {
  Death_Natural: 'Natural Death',
  Death_Accidental: 'Accidental Death',
  Death_PreExistingCondition: 'Death from Pre-existing Condition'
};

// DFCU splits its death cover into one benefit per cause, so the benefit picked on
// the member step already states the cause. Defaulting off it keeps the declared
// cause and the benefit being claimed against from contradicting each other.
export const causeOfDeathFromBenefits = benefits => {
  if (!benefits) {
    return '';
  }

  for (let benefit of benefits) {
    const cause = benefit && CAUSE_BY_BENEFIT_TYPE[benefit.type];
    if (cause) {
      return cause;
    }
  }

  return '';
};
